export default "__VITE_ASSET__BNCDY4LN__"